import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { AnyProductType } from "../constants/productTypes";
import { NullableLanguageMap } from "../i18n/useLanguage";
import {
  DealerProductDetailsRoute,
  DealerVehicleResultsRoute,
} from "../navigation/DealerRoutes";
import { useDealerRoutesParams } from "../navigation/useDealerRoutesParams";
import { useSomeRoutes } from "../navigation/useSomeRoutes";
import { useDealerAccountInfo } from "../stores/hooks/useDealerAccountInfo";
import { productTypeToPartType } from "../util/productTypeToPartType";

export const useValidateVehicleKeys = (): ModifiedSWRResponse<
  FetcherResult<Payload>,
  Payload
> => {
  const route = useDealerRoutesParams();
  const { dealerNationalAccountId } = useDealerAccountInfo();
  const partType =
    productTypeToPartType(route?.productType as AnyProductType) || "";
  const shouldFetch = useSomeRoutes(
    DealerVehicleResultsRoute,
    DealerProductDetailsRoute
  );
  const result = useSwrGet<Payload>(
    shouldFetch
      ? "/retailSiteWebService/vehicle/validateVehicleKeys.php"
      : null,
    {
      dealerId: route?.dealerId || "",
      isNational: "0",
      nationalAccountId: dealerNationalAccountId,
      partType,
      vehicleCategoryName: route.vehicleModelClassId || "",
      vehicleManufacturerName: route.vehicleManufacturerName || "",
      vehicleModelName: route.vehicleModelName || "",
      vehicleSubmodelName: route.vehicleSubmodel || "",
      vehicleYear: route.vehicleYear || "",
    }
  );
  return result;
};

type Payload = {
  vehicleCategoryId: number;
  vehicleCategoryName: NullableLanguageMap;
  vehicleManufacturerId: number;
  vehicleManufacturerImage: string;
  vehicleManufacturerName: string;
  vehicleModelId: number;
  vehicleModelImage: string;
  vehicleModelName: NullableLanguageMap;
  vehicleSubmodelId: number;
  vehicleSubmodelImage?: string;
  vehicleSubmodelName: NullableLanguageMap;
  vehicleYearId: number;
  vehicleYearName: string;
};
